import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import Style from 'styles/components/comachicart/price.module.scss';

const Price = ({visibleVoice}) => {
  return (
    <section className={Style.price}>
      <h2 className={classNames(Style.catch)}>
        <span>料金体系</span>
      </h2>
      {visibleVoice ? (
        <>
          <h3 className={classNames(Style.dogear, Style.price__plan)}>
            <span>スタンダードプランの料金体系</span>
          </h3>
        </>
      ) : (
        <>
          <h3 className={classNames(Style.price__plan, Style.third_catch)}>
            <span>スタンダードプランの料金体系</span>
          </h3>
        </>
      )}
      <div className={Style.price__table}>
        <div className={Style.price__table__column}>
          <table>
            <thead>
              <tr>
                <th colSpan={2}>カートシステム利用料金</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>初期費用</td>
                <td>
                  <span>0円</span>
                </td>
              </tr>
              <tr>
                <td>月額費用</td>
                <td>
                  <span>0円</span>
                </td>
              </tr>
              <tr>
                <td>システム利用料</td>
                <td>　3%<sup className={classNames(Style.fs11)}>※1</sup></td>
              </tr>
            </tbody>
          </table>
          <p className={classNames(Style.pt0, Style.pb0, Style.fs12)}>※1 システム利用料は【税込】価格となります。</p>
        </div>
        <div className={Style.price__table__column}>
          <table>
            <thead>
              <tr>
                <th colSpan={2}>
                  <p className={classNames(Style.pt0, Style.pb0)}>　クレジットカード決済利用料金<sup className={classNames(Style.fs11)}>※2</sup></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>初期費用</td>
                <td>
                  <span>0円</span>
                </td>
              </tr>
              <tr>
                <td>月額費用</td>
                <td>0円</td>
              </tr>
              <tr>
                <td>決済手数料</td>
                <td>　3.5%<sup className={classNames(Style.fs11)}>※3</sup></td>
              </tr>
              <tr>
                <td>売上処理料</td>
                <td>0円</td>
              </tr>
            </tbody>
          </table>
          <p className={classNames(Style.pt0, Style.pb0, Style.fs12)}>※2 決済手段としてクレジットカード決済をご利用の場合、発生する料金になります。</p>
          <p className={classNames(Style.pt0, Style.pb0, Style.fs12)}>※3 決済手数料は【税抜】価格となります。</p>
        </div>
      </div>
      <div className={classNames(Style.price__notice)}>
        <span className={Style.price__notice__icon}>
          <FontAwesomeIcon className={Style.price__notice__icon__inner} icon={
    faExclamationTriangle} />
        </span>
        <div className={classNames(Style.price__notice__text)}>
          <div>※システム利用料は、各販売ごとの売上（送料及び消費税を含む）に対して3%発生致します。</div>
          <div>※クレジットカード決済利用料金は、「株式会社ゼウス」の決済サービスのご利用料金となります。</div>
          <div style={{
    color: 'red' }}>　当社経由のお申込みの場合、記載の料金が適用になります。</div>
          <div>
          　サービス内容の詳細は、
            <a
              className={classNames(Style.price__notice__link)}
              href='https://www.cardservice.co.jp/service/creditcard/'
            >
              ゼウス社のホームページ
            </a>
            をご参照ください。
          </div>
          <div>※その他、ご利用になられる決済手段に応じて、各決済サービスで定められた料金が発生致します。</div>
        </div>
      </div>
    </section>
  );
};
export default Price;
